// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-cart{position:relative;width:-moz-fit-content;width:fit-content;display:block}.icon-cart__counter{background-color:#00a33b;font-size:.416667em;min-height:1em;min-width:1em;max-width:5em;color:#fff;line-height:1;padding:.25em .5em;overflow:hidden;text-align:center;transform-origin:top right;position:absolute;border-radius:1em;top:-.5em;right:-.5em;font-weight:700}", ""]);
// Exports
module.exports = exports;
